<template>
    <modal name="update_permissions" height="auto" scrollable adaptive @before-open="beforeOpen">
        <app-card :title="$t('Edit permissions')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="update(validate)">
                    <div class="row">
                        <div class="col">
                            <app-checkbox v-for="(permission, i) in permissions"
                                          :key="i"
                                          :topMargin="0"
                                          :id="`${permission.node}`"
                                          :name="`${permission.node}`"
                                          :value="hasPermission(permission.id)"
                                          @input="addPermission(permission.id)">
                                {{ permission.name[locale] }}
                            </app-checkbox>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Update') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import RoleService from '@services/role.service';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            form: {},
            permissions: [],
            loading: false,
            role_id: null
        };
    },
    computed: {
        ...mapGetters(['locale'])
    },
    methods: {
        hasPermission(permissionId) {
            const perm = this.form.permissions.find(p => p === permissionId);
            if (perm) {
                return true;
            }
            return false;
        },
        addPermission(permissionId) {
            const index = this.form.permissions.findIndex(p => p === permissionId);
            if (index !== -1) {
                this.form.permissions.splice(index, 1);
            } else {
                this.form.permissions.push(permissionId);
            }
        },
        getPermissions() {
            RoleService.permissions().then(res => this.permissions = res);
        },
        update(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    RoleService.updatePermissions(this.role_id, this.form).then(res => {
                        this.$toastr.s(this.$t('Updated'));
                        this.loading = false;
                        this.hide();
                        this.$store.dispatch('GET_USER_PERMISSIONS');
                        this.$emit('setRole', res);
                    });
                }
            });
        },
        beforeOpen(event) {
            const role = event.params.role;
            if (role) {
                this.form.permissions = role.permissions ? role.permissions.map(p => p.id) : [];
                this.role_id = role.id;
            }
        },
        hide() {
            this.$modal.hide('update_permissions');
        }
    },
    created() {
        this.getPermissions();
    }
};
</script>
